import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { OngoingRequestTrackerService, SessionService } from '@core';

import { Patient } from '../../models/patient.model';
import { OfficeInfo } from '../../models/office-info.model';
import { AddressFinderResult } from '../../models/address-finder-result.model';
import {EmployeeAdminTaskAddress} from "../../models/employee-admin-task-address.model";

@Injectable({
    providedIn: 'root'
})
export class AddressFinderService {
    private readonly httpClient = inject(HttpClient);
    private readonly sessionService = inject(SessionService);
    private readonly ongoingRequestTracker = inject(OngoingRequestTrackerService);


    public validateAddress(patient: Patient, office: OfficeInfo): Observable<AddressFinderResult> {
        return this.validateAddresses([patient], office);
    }
    public validateAdminTaskAddress(address: EmployeeAdminTaskAddress, office: OfficeInfo): Observable<AddressFinderResult> {
        return this.validateAdminTaskAddresses([address], office);
    }

    public validateAddresses(patients: Patient[], office: OfficeInfo): Observable<AddressFinderResult> {
        const url = `${this.sessionService.getApiUrl()}/validate_addresses/`;
        const body = {
            officeInfo: JSON.parse(JSON.stringify(office)),
            patients: JSON.parse(JSON.stringify(patients))
        };
        const requestOptions = this.ongoingRequestTracker.createTrackingEnabledRequestOptions();

        return this.httpClient.put<AddressFinderResult>(url, body, requestOptions);
    }
    public validateAdminTaskAddresses(addresses: EmployeeAdminTaskAddress[], office: OfficeInfo): Observable<AddressFinderResult> {
        const url = `${this.sessionService.getApiUrl()}/validate_admin_task_addresses/`;
        const body = {
            officeInfo: JSON.parse(JSON.stringify(office)),
            addresses: JSON.parse(JSON.stringify(addresses))
        };
        const requestOptions = this.ongoingRequestTracker.createTrackingEnabledRequestOptions();

        return this.httpClient.put<AddressFinderResult>(url, body, requestOptions);
    }
}
